/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import {dlsDarkColor} from '@ion/dls/src/theme/theme';

/**
 * Returns the primary text color: the original dark grey in light mode, the
 * DLS grey1 token in dark mode. Shared by the Sentinel tabs and the account
 * type tag.
 *
 * @param   isDark `true` when dark mode is active.
 * @returns The primary text color for the given mode.
 */
export const getPrimaryTextColor = (isDark: boolean): string => (
  dlsDarkColor(isDark, 'grey1', 'rgba(51, 51, 51, 1)')
);
